module.exports = __webpack_public_path__ + "static/media/VasOutline.9c1103e1.png";